import React from 'react';
import { View, Text, StyleSheet, Image, Dimensions, TouchableOpacity } from 'react-native';

import i18n from 'i18n-js';
import { moderateScale, isIOS, navigateTo, isPhone } from '@helpers';

import TabletWrapper from '@components/auntification/tablerWrapper/index';
import {
  AUTH_LOGO_MARGIN_TOP_CONNECTOR,
  AUTH_LOGO_OFFSET_CONNECTOR,
  AUTH_OFFSET_CONNECTOR,
} from '../tablerWrapper/constants';
import Logo from '@components/logo/index';

import welcomeImage from '@assets/img/man-machine.jpg';

import ColorsWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import useStatusBar from '@components/common/useStatusBar';

const ConnectorEmail = ({ C }) => {
  const devWidth = Dimensions.get('window').width;
  useStatusBar({ C });
  const returnHome = () => {
    // navigateTo('Login', {
    //   site: true,
    //   text: i18n.t('First install the free Connector'),
    // });
    navigateTo('Login');
  };

  const coef = devWidth / 382;
  let childSize = {
    width: isPhone ? devWidth : moderateScale(382),
    height: isPhone ? 245 * coef : moderateScale(245),
  };

  return (
    <TabletWrapper offset={AUTH_OFFSET_CONNECTOR}>
      <View style={styles.topContainer}>
        <View style={styles.logoBox}>
          <Logo
            title={i18n.t('Welcome')}
            small
            marginTop={AUTH_LOGO_MARGIN_TOP_CONNECTOR}
            offset={AUTH_LOGO_OFFSET_CONNECTOR}
          />
        </View>
        <View style={styles.childImgBox}>
          <Image style={[childSize]} source={welcomeImage} resizeMode="cover" />
        </View>
        <Text style={[styles.welcomeText, { color: C('Label / Light / Secondary') }, font['Subhead 2']]}>
          {/* {i18n.t('First install the Connector on a Windows Server')} */}
          {i18n.t('You need to install the Smart Factory Connector to use this app. We will contact you soon to help you to get started.')}
        </Text>
      </View>
      <View style={styles.bottomContainer}>
        <TouchableOpacity onPress={returnHome}>
          <Text
            style={[
              styles.actionText,
              { color: C('Label / Light / Secondary') },
              // missingFont
            ]}
          >
            {i18n.t('Back to start screen')}
          </Text>
        </TouchableOpacity>
      </View>
    </TabletWrapper>
  );
};

export default ColorsWrapper(ConnectorEmail);

const styles = StyleSheet.create({
  actionText: {
    fontWeight: 'bold',
    fontSize: moderateScale(12),
    textAlign: 'center',
    letterSpacing: moderateScale(0.01),
  },
  childImgBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    marginBottom: moderateScale(!isPhone ? 33 : 17),
    marginTop: moderateScale(-5),
  },
  welcomeText: {
    fontWeight: 'normal',
    fontSize: moderateScale(14),
    textAlign: 'center',
    letterSpacing: moderateScale(0.02),
    lineHeight: moderateScale(21),
  },
  logoBox: {
    alignItems: 'center',
    marginBottom: moderateScale(!isPhone ? 25 : 0),
  },
  topContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: moderateScale(!isPhone ? 382 : 302),
  },
  bottomContainer: {
    marginTop: moderateScale(isIOS ? (isPhone ? 43 : 32) : 43),
    maxWidth: moderateScale(!isPhone ? 382 : 302),
    marginBottom: moderateScale(20),
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '100%',
  },
});
